export class DialogSearchData {
    public constructor(
        public searchNameTitle: string,
        public text: string = null
    ) {}
}
